let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kjkY9")).then(() => parcelRequire('e5DTv'));